import { produce } from "immer";

import type { ConfigActions } from "./actions";

export interface IConfigState {
  apiUrl: string;
  returnUrl: string;
  isProduction: boolean;
}

function getApiUrl(currentHostname: string): string {
  if (currentHostname === "theirstory-react.ngrok.io") {
    return "https://theirstory-node.ngrok.io";
  }
  if (currentHostname === "ts-react.ngrok.io") {
    return "https://ts-node.ngrok.io";
  }

  // staging
  if (currentHostname === "ts-frontend-staging.herokuapp.com") {
    return "https://ts-backend-staging.herokuapp.com";
  }

  // staging
  if (currentHostname === "staging.theirstory.io") {
    return "https://stagingnode.theirstory.io";
  }

  // production
  if (currentHostname === "ts-frontend-alpha.herokuapp.com") {
    return "https://ts-backend-alpha.herokuapp.com";
  }

  // production
  if (
    currentHostname === "alpha.theirstory.io" ||
    currentHostname === "theirstory.io" ||
    currentHostname === "www.theirstory.io" ||
    currentHostname === "theirstory.netlify.app"
  ) {
    return "https://node.theirstory.io";
  }

  // provided api url
  if (process.env.API_BASE_URL && process.env.API_BASE_URL.length > 0) {
    return process.env.API_BASE_URL;
  }

  // local
  // noinspection HttpUrlsUsage
  return `http://${window.location.hostname}:8080`;
}

function getReturnUrl(currentHostname: string): string {
  // staging
  if (currentHostname === "staging.theirstory.io") {
    return "https://staging.theirstory.io";
  }

  // production
  if (
    currentHostname === "alpha.theirstory.io" ||
    currentHostname === "theirstory.io" ||
    currentHostname === "www.theirstory.io" ||
    currentHostname === "theirstory.netlify.app"
  ) {
    return "https://theirstory.io";
  }

  // local development
  return `http://${window.location.hostname}:8001`;
}

function isProduction(currentHostname: string): boolean {
  return (
    currentHostname === "alpha.theirstory.io" ||
    currentHostname === "theirstory.io" ||
    currentHostname === "www.theirstory.io" ||
    currentHostname === "theirstory.netlify.app"
  );
}

export const initialState: IConfigState = {
  apiUrl: getApiUrl(window.location.hostname),
  returnUrl: getReturnUrl(window.location.hostname),
  isProduction: isProduction(window.location.hostname),
};

export const configReducer = produce((draft: IConfigState, action: ConfigActions) => {
  switch (action.type) {
    case "SET_CONFIG": {
      Object.assign(draft, action.payload);
      break;
    }
    default:
      break;
  }
}, initialState);
